import { useVisitorData } from '@mentimeter/visitor/visitor-data';
import { hasMonthlyBillingEnabled } from '../utils/hasMonthlyBillingEnabled';

export function useMonthlyBilling() {
  const { visitorData, isLoading } = useVisitorData();
  const monthlyBillingIsSupported = hasMonthlyBillingEnabled(
    visitorData?.country,
  );

  return { monthlyBillingIsSupported, isLoading };
}
